// Runtime gaps between the engines we ship on. The bundle is compiled for
// Chrome 83 SYNTAX (the D4's WebView), but syntax isn't the whole story: an
// engine can parse the code and still lack an API. Firefox 68 — the last
// Gecko for Android 4.4, inside kds-shell/ on the Elo I-Series till — is the
// one that bit: `queueMicrotask` (Firefox 69) was reached during boot and the
// whole page died before its first render. Imported FIRST by every entry.
// Each shim installs only when the engine lacks the API.

const g = globalThis as any;

if (typeof g.queueMicrotask !== "function") {
  g.queueMicrotask = (cb: () => void) => {
    Promise.resolve().then(cb).catch((e) => setTimeout(() => { throw e; }, 0));
  };
}

if (typeof Promise.allSettled !== "function") {
  (Promise as any).allSettled = function <T>(items: Iterable<T | PromiseLike<T>>) {
    return Promise.all(
      Array.from(items, (p) =>
        Promise.resolve(p).then(
          (value) => ({ status: "fulfilled" as const, value }),
          (reason) => ({ status: "rejected" as const, reason })
        )
      )
    );
  };
}

if (typeof g.crypto !== "undefined" && typeof g.crypto.randomUUID !== "function" && typeof g.crypto.getRandomValues === "function") {
  g.crypto.randomUUID = () => {
    const b = new Uint8Array(16);
    g.crypto.getRandomValues(b);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  };
}

// ResizeObserver (Firefox 69 / Chrome 64): the app already guards its two
// uses, but a guard means "never re-measure" — the kitchen board would pack
// columns for a 200 px board forever. A simple observer that re-checks on
// window resize and on a slow tick is enough for a fixed kiosk screen.
if (typeof g.ResizeObserver === "undefined") {
  type Entry = { target: Element; contentRect: DOMRectReadOnly };
  class SimpleResizeObserver {
    private cb: (entries: Entry[]) => void;
    private els = new Map<Element, string>();
    private timer = 0;
    private onResize = () => this.check();
    constructor(cb: (entries: Entry[]) => void) { this.cb = cb; }
    observe(el: Element) {
      this.els.set(el, "");
      if (!this.timer) {
        window.addEventListener("resize", this.onResize);
        this.timer = window.setInterval(this.onResize, 1000);
      }
      // First notification, like the real thing.
      setTimeout(() => this.check(true), 0);
    }
    unobserve(el: Element) { this.els.delete(el); if (!this.els.size) this.disconnect(); }
    disconnect() {
      this.els.clear();
      window.removeEventListener("resize", this.onResize);
      if (this.timer) window.clearInterval(this.timer);
      this.timer = 0;
    }
    private check(force = false) {
      const entries: Entry[] = [];
      this.els.forEach((last, el) => {
        const r = el.getBoundingClientRect();
        const key = `${r.width}x${r.height}`;
        if (force || key !== last) {
          this.els.set(el, key);
          entries.push({ target: el, contentRect: r });
        }
      });
      if (entries.length) this.cb(entries);
    }
  }
  g.ResizeObserver = SimpleResizeObserver;
}

export {};
